import { render, staticRenderFns } from "./StepPopulateTemplateFriends.vue?vue&type=template&id=13cd0e14&scoped=true&"
import script from "./StepPopulateTemplateFriends.vue?vue&type=script&lang=js&"
export * from "./StepPopulateTemplateFriends.vue?vue&type=script&lang=js&"
import style0 from "./StepPopulateTemplateFriends.vue?vue&type=style&index=0&id=13cd0e14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cd0e14",
  null
  
)

export default component.exports